export default {
  horizontalMenuCommit (state, data) {
    state.horizontalMenu = data
  },
  miniSidebarCommit (state, data) {
    state.miniSidebarMenu = data
  },
  authUserCommit (state, data) {
    state.authUser = data
  },
  addUserCommit (state, data) {
    state.users.push(data)
  },
  activePageCommit (state, data) {
    state.activePage = data
  },
  addBookmarkCommit (state, data) {
    state.bookmark.push(data)
  },
  removeBookmarkCommit (state, data) {
    let book = state.bookmark.findIndex(item => item.link.name === data.link.name)
    if (book !== -1) {
      state.bookmark.splice(book, 1)
    }
  },
  setLangCommit (state, data) {
    state.lang = data
  },
  darkModeCommit (state, data) {
    state.darkMode = data
  },
  serverErrorCommit (state, msg) {
    if (msg) { state.serverErrors = `Lỗi: ${msg}` } else {
      state.serverErrors = ''
    }
  },
  serverRequestingCommit (state, dataBoolean) {
    state.serverRequesting = dataBoolean
  }
}
